/* eslint-disable */

import { Tooltip } from '@mui/material';
import { ExternalLink, Info } from 'lucide-react';

const getColorWithOpacity = (color, opacity) => {
	if (!color) return `rgba(139, 92, 246, ${opacity})`;
	if (color.startsWith('rgba')) {
		return color.replace(/[\d.]+\)$/, `${opacity})`);
	}
	if (color.startsWith('rgb(')) {
		const match = color.match(/rgb\((\d+)[,\s]+(\d+)[,\s]+(\d+)\)/);
		if (match) {
			return `rgba(${match[1]}, ${match[2]}, ${match[3]}, ${opacity})`;
		}
		return color.replace('rgb(', 'rgba(').replace(')', `, ${opacity})`);
	}

	if (color.startsWith('#')) {
		const hex = color.slice(1);
		const r = parseInt(hex.substr(0, 2), 16);
		const g = parseInt(hex.substr(2, 2), 16);
		const b = parseInt(hex.substr(4, 2), 16);
		return `rgba(${r}, ${g}, ${b}, ${opacity})`;
	}
	return `color-mix(in srgb, ${color} ${Math.round(
		opacity * 100
	)}%, transparent)`;
};

function StatsComp(props) {
	const { statsCards = [], onStatsClick } = props;
	return (
		<div
			style={{
				marginBottom: '24px',
			}}
		>
			<div
				style={{
					display: 'flex',
					gap: '12px',
					flexWrap: 'nowrap',
				}}
			>
				{statsCards?.map((stat, index) => (
					<div
						key={index}
						className={`${stat.textColor || ''}`}
						style={{
							flex: '1 1 auto',
							// minWidth: '0',
							borderRadius: '10px',
							padding: '14px',
							border: `1px solid ${getColorWithOpacity(
								stat.color,
								0.35
							)}`,
							boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06)',
							position: 'relative',
							overflow: 'hidden',
							transition: 'all 0.2s ease',
							background: stat.v2
								? '#fff'
								: stat.percentageValue != null
									? `linear-gradient(90deg, ${getColorWithOpacity(
										stat.color,
										0.35
									)} 0%, ${getColorWithOpacity(
										stat.color,
										0.35
									)} ${Math.min(
										parseFloat(stat.percentageValue) || 0,
										100
									)}%, ${getColorWithOpacity(
										stat.color,
										0.001
									)} ${Math.min(
										parseFloat(stat.percentageValue) || 0,
										100
									)}%, ${getColorWithOpacity(
										stat.color,
										0.001
									)} 100%)`
									: `linear-gradient(135deg, ${getColorWithOpacity(
										stat.color,
										0.32
									)} 0%, ${getColorWithOpacity(
										stat.color,
										0.22
									)} 100%)`,
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.boxShadow =
								'0 4px 10px rgba(0, 0, 0, 0.12)';
							e.currentTarget.style.transform =
								'translateY(-2px)';
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.boxShadow =
								'0 2px 6px rgba(0, 0, 0, 0.08)';
							e.currentTarget.style.transform = 'translateY(0)';
						}}
					>
						{stat.v2 ? (
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									gap: '6px',
								}}
							>
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'flex-end',
									}}
								>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											gap: '2px',
										}}
									>
										<div
											style={{
												fontSize: '13px',
												fontWeight: '600',
												color: stat.color || '#374151',
												lineHeight: '1.2',
												display: 'flex',
												alignItems: 'center',
												gap: '3px',
											}}
										>
											{stat.label}
											{(stat?.redirect || (stat?.hasModalClick && onStatsClick)) && (
												<Tooltip title={stat?.tooltipLabel || (stat?.redirect ? 'Go to Quality Analysis' : 'View Details')}>
													{stat.img ? (
														<img
															src={stat.img}
															alt=""
															style={{ width: 14, height: 14, cursor: 'pointer' }}
															onClick={(e) => {
																e.stopPropagation();
																if (stat.redirect) window.open(stat?.link, '_blank');
																else onStatsClick(stat);
															}}
														/>
													) : (
														(() => {
															const IconComponent = stat.icon || (stat.redirect ? ExternalLink : Info);
															return (
																<IconComponent
																	size={14}
																	style={{ cursor: 'pointer' }}
																	onClick={(e) => {
																		e.stopPropagation();
																		if (stat.redirect) window.open(stat?.link, '_blank');
																		else onStatsClick(stat);
																	}}
																/>
															);
														})()
													)}
												</Tooltip>
											)}
										</div>
										{stat?.subText && (
											<div
												style={{
													fontSize: '11px',
													color: '#6b7280',
													fontWeight: '500',
													maxWidth: '120%',
												}}
											>
												{stat.subText}
											</div>
										)}
									</div>
									<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px' }}>
										<div style={{
											fontSize: '18px',
											fontWeight: '700',
											color: stat.color || '#111827',
											lineHeight: '1',
											whiteSpace: 'nowrap'
										}}>
											{stat?.value}
										</div>
										{stat.percentageRightLabel && (
											<div
												style={{
													fontSize: '11px',
													fontWeight: '600',
													color:
														stat.color || '#374151',
													lineHeight: '1',
												}}
											>
												{stat.percentageRightLabel}
											</div>
										)}
									</div>
								</div>

								{/* Progress Bar */}
								<div
									style={{
										width: '100%',
										height: '6px',
										background: getColorWithOpacity(
											stat.color,
											0.15
										),
										borderRadius: '99px',
										overflow: 'hidden',
									}}
								>
									<div
										style={{
											width: `${Math.min(
												parseFloat(
													stat.percentageValue
												) || 0,
												100
											)}%`,
											height: '100%',
											background: stat.color || '#3b82f6',
											borderRadius: '99px',
											transition: 'width 0.5s ease-out',
										}}
									/>
								</div>
							</div>
						) : (
							<>
								{/* Percentage Badge */}
								{stat?.percentageValue != null ? (
									<div
										style={{
											position: 'absolute',
											top: '2px',
											right: '2px',
											background:
												'rgba(255, 255, 255, 0.9)',
											borderRadius: '6px',
											padding: '3px 8px',
											fontSize: '11px',
											fontWeight: '700',
											boxShadow:
												'0 1px 3px rgba(0, 0, 0, 0.1)',
											color: stat.isNegative
												? '#dc2626'
												: '#059669',
										}}
									>
										{stat?.percentageValue}%
									</div>
								) : null}

								<div
									style={{
										fontSize: '24px',
										fontWeight: '700',
										marginBottom: '8px',
										lineHeight: '1.2',
										letterSpacing: '-0.3px',
										whiteSpace: 'nowrap',
									}}
								>
									{stat?.value}
								</div>

								<div
									style={{
										fontSize: '12px',
										fontWeight: '600',
										marginBottom: '3px',
										lineHeight: '1.3',
										display: 'flex',
										alignItems: 'center',
										gap: '3px',
									}}
								>
									{stat?.label}
									{(stat?.redirect || (stat?.hasModalClick && onStatsClick)) && (
										<Tooltip title={stat?.tooltipLabel || (stat?.redirect ? 'Go to Quality Analysis' : 'View Details')}>
											{stat.img ? (
												<img
													src={stat.img}
													alt=""
													style={{ width: 14, height: 14, cursor: 'pointer' }}
													onClick={(e) => {
														e.stopPropagation();
														if (stat.redirect) window.open(stat?.link, '_blank');
														else onStatsClick(stat);
													}}
												/>
											) : (
												(() => {
													const IconComponent = stat.icon || (stat.redirect ? ExternalLink : Info);
													return (
														<IconComponent
															size={14}
															style={{ cursor: 'pointer' }}
															onClick={(e) => {
																e.stopPropagation();
																if (stat.redirect) window.open(stat?.link, '_blank');
																else onStatsClick(stat);
															}}
														/>
													);
												})()
											)}
										</Tooltip>
									)}
								</div>

								<div
									style={{
										fontSize: '10px',
										opacity: 0.75,
										fontWeight: '500',
										lineHeight: '1.2',
										width: '120%',
									}}
								>
									{stat?.subText}
								</div>

								{stat?.subText2 && (
									<div
										style={{
											fontSize: '10px',
											opacity: 0.75,
											fontWeight: '500',
											lineHeight: '1.2',
											width: '120%',
											marginTop: '2px',
										}}
									>
										{stat.subText2}
									</div>
								)}

								<div
									style={{
										position: 'absolute',
										bottom: '-15px',
										right: '-15px',
										width: '60px',
										height: '60px',
										background: 'rgba(255, 255, 255, 0.15)',
										borderRadius: '50%',
										pointerEvents: 'none',
									}}
								/>
							</>
						)}
					</div>
				))}
			</div>
		</div>
	);
}
export default StatsComp;
